/**
 * Jadwal berulang sebagai frekuensi, jam mulai, dan hari; bentuk simpanannya cron.
 *
 * `dariCron` hanya mengenali bentuk yang dirakit `keCron` (`0 H,H,H * * D`). Jadwal yang
 * ditulis di luar layar tidak dipaksa ke bentuk terdekat: memaksanya berarti membuka layar
 * lalu diam-diam mengubah jadwal yang tidak disentuh siapa pun.
 */

/** Jam-jam yang dihasilkan frekuensi N per hari, mulai dari `mulai`. */
export function jamDariFrekuensi(n, mulai) {
  const jarak = Math.floor(24 / n)
  return Array.from({ length: n }, (_, i) => (mulai + i * jarak) % 24).sort((a, b) => a - b)
}

export function keCron({ frekuensi, mulai, hari }) {
  const jam = jamDariFrekuensi(frekuensi, mulai).join(',')
  // ISO 1-7 (Senin-Minggu) -> cron 0-6 (Minggu-Sabtu). Minggu = 7 di ISO, 0 di cron;
  // memetakannya salah menggeser SELURUH minggu satu hari, dan hasilnya tetap cron yang sah.
  const dow = [...hari].sort((a, b) => a - b).map((d) => (d === 7 ? 0 : d)).join(',')
  const semuaHari = hari.length === 7
  return `0 ${jam} * * ${semuaHari ? '*' : dow}`
}

export function dariCron(cron) {
  const p = String(cron || '').trim().split(/\s+/)
  if (p.length !== 5 || p[0] !== '0' || p[2] !== '*' || p[3] !== '*') return null
  const jam = p[1].split(',').map(Number)
  if (!jam.length || jam.some((h) => !Number.isInteger(h) || h < 0 || h > 23)) return null
  // Jaraknya harus rata — itu yang membedakan hasil rakitan layar ini dari cron bebas.
  const urut = [...jam].sort((a, b) => a - b)
  const jarak = Math.floor(24 / urut.length)
  const cocok = jamDariFrekuensi(urut.length, urut[0]).join(',') === urut.join(',')
  if (!cocok || jarak * urut.length !== 24) return null

  const hari = p[4] === '*'
    ? [1, 2, 3, 4, 5, 6, 7]
    : p[4].split(',').map(Number).map((d) => (d === 0 ? 7 : d))
  if (hari.some((d) => !Number.isInteger(d) || d < 1 || d > 7)) return null
  return { frekuensi: urut.length, mulai: urut[0], hari: hari.sort((a, b) => a - b) }
}
